import React, { useState } from 'react';
import bootstrapBundleMin from 'bootstrap/dist/js/bootstrap.bundle.min';
import api from '../utils/api';
import { getLastPage } from './lastPage';

const TITLE_MAX = 120;
const DESCRIPTION_MAX = 5000;

const TYPES = [
    { value: 'bug', label: 'Bug' },
    { value: 'feature', label: 'Feature request' },
    { value: 'question', label: 'Question' },
];

const emptyForm = { type: 'bug', title: '', description: '' };

const FeedbackModal = () => {
    const [form, updateForm] = useState(emptyForm);
    const [submitting, updateSubmitting] = useState(false);
    const [error, updateError] = useState('');
    const [submittedNumber, updateSubmittedNumber] = useState(null);

    const setField = field => e =>
        updateForm({ ...form, [field]: e.target.value });

    const reset = () => {
        updateForm(emptyForm);
        updateError('');
        updateSubmittedNumber(null);
    };

    const submit = e => {
        e.preventDefault();
        updateSubmitting(true);
        updateError('');
        api.post('/api/v1/feedback', {
            ...form,
            pageUrl: getLastPage(),
            userAgent: `${navigator.userAgent} (${window.innerWidth}x${window.innerHeight})`,
        })
            .then(({ data }) => {
                updateSubmittedNumber(data.number);
                updateForm(emptyForm);
            })
            .catch(err => {
                // Keep the form contents so the user doesn't lose their text.
                updateError(
                    err.response?.data?.error ||
                        'Something went wrong. Please try again.',
                );
            })
            .finally(() => updateSubmitting(false));
    };

    const close = () => {
        const modal = document.getElementById('feedbackModal');
        bootstrapBundleMin.Modal.getInstance(modal)?.hide();
    };

    return (
        <div
            className='modal fade'
            id='feedbackModal'
            tabIndex='-1'
            aria-labelledby='feedbackModalLabel'
            aria-hidden='true'
        >
            <div className='modal-dialog modal-dialog-scrollable'>
                <div className='modal-content bg-dark text-white border-secondary'>
                    <div className='modal-header border-secondary'>
                        <h5 className='modal-title' id='feedbackModalLabel'>
                            Send Feedback
                        </h5>
                        <button
                            type='button'
                            className='btn-close btn-close-white'
                            data-bs-dismiss='modal'
                            aria-label='Close'
                            onClick={reset}
                        ></button>
                    </div>
                    {submittedNumber ? (
                        <>
                            <div className='modal-body'>
                                <p className='mb-0'>
                                    <i className='bi bi-check-circle-fill text-success me-2'></i>
                                    Thanks, submitted as #{submittedNumber}.
                                </p>
                            </div>
                            <div className='modal-footer border-secondary'>
                                <button
                                    type='button'
                                    className='btn btn-secondary'
                                    onClick={() => {
                                        close();
                                        reset();
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </>
                    ) : (
                        <form onSubmit={submit}>
                            <div className='modal-body'>
                                {error && (
                                    <div className='alert alert-danger'>
                                        {error}
                                    </div>
                                )}
                                <div className='mb-3'>
                                    <label
                                        htmlFor='feedbackType'
                                        className='form-label'
                                    >
                                        Type
                                    </label>
                                    <select
                                        id='feedbackType'
                                        className='form-select bg-dark text-white border-secondary'
                                        value={form.type}
                                        onChange={setField('type')}
                                    >
                                        {TYPES.map(t => (
                                            <option
                                                key={t.value}
                                                value={t.value}
                                            >
                                                {t.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='mb-3'>
                                    <label
                                        htmlFor='feedbackTitle'
                                        className='form-label'
                                    >
                                        Title
                                    </label>
                                    <input
                                        id='feedbackTitle'
                                        className='form-control bg-dark text-white border-secondary'
                                        maxLength={TITLE_MAX}
                                        value={form.title}
                                        onChange={setField('title')}
                                        required
                                    />
                                </div>
                                <div className='mb-3'>
                                    <label
                                        htmlFor='feedbackDescription'
                                        className='form-label'
                                    >
                                        Description
                                    </label>
                                    <textarea
                                        id='feedbackDescription'
                                        className='form-control bg-dark text-white border-secondary'
                                        rows={6}
                                        maxLength={DESCRIPTION_MAX}
                                        value={form.description}
                                        onChange={setField('description')}
                                        required
                                    />
                                </div>
                                <div className='form-text text-secondary'>
                                    Page: {getLastPage()}. Your username and
                                    browser are included automatically.
                                </div>
                            </div>
                            <div className='modal-footer border-secondary'>
                                <button
                                    type='button'
                                    className='btn btn-secondary'
                                    data-bs-dismiss='modal'
                                >
                                    Cancel
                                </button>
                                <button
                                    type='submit'
                                    className='btn btn-primary'
                                    disabled={submitting}
                                >
                                    {submitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
